import { IconButton, Typography } from "@mui/material";
import Drawer from "@mui/material/Drawer/Drawer";
import { ReactComponent as ChevronRightIcon } from "components/Icons/chevron-right.svg";
import { ReactComponent as XCloseIcon } from "components/Icons/x-close.svg";
import { useMessage } from "hooks/intl";
import { OLButton } from "OLButton";
import { useState } from "react";
import { SelectedFilter } from "types/filters";
import { useStyles } from "../styles";
import { parseFilterValue } from "../utils";
import { Filter } from "./Filter.tsx";

interface Props {
  selectedFilters: SelectedFilter[];
  isOpen: boolean;
  onClose: () => void;
  clearFilters: () => void;
  properties: SelectedFilter[];
  replace: (index: number, value: SelectedFilter) => void;
  handleSubmit: () => void;
}

export function FiltersSidebar({
  isOpen,
  selectedFilters,
  onClose,
  clearFilters,
  properties,
  replace,
  handleSubmit,
}: Props) {
  const classes = useStyles();
  const { message } = useMessage();
  const [editedFilter, setEditedFilter] = useState<{
    filter: SelectedFilter | null;
    index: number | null;
  }>({
    filter: null,
    index: null,
  });

  return (
    <Drawer
      open={isOpen}
      anchor="right"
      onClose={onClose}
      classes={{
        paper: classes.sidebar,
      }}
    >
      <div className={classes.header}>
        <Typography>{message({ id: "listOfSelectedFilters" })}</Typography>
        <IconButton onClick={onClose}>
          <XCloseIcon />
        </IconButton>
      </div>
      <div className={classes.sidebarContent}>
        {editedFilter.filter ? (
          <Filter
            editedFilter={editedFilter}
            onClose={() => setEditedFilter({ filter: null, index: null })}
            selectedFilters={selectedFilters}
            properties={properties}
            replace={replace}
            saveFilter={() => {
              setEditedFilter({ filter: null, index: null });
              handleSubmit();
            }}
            setEditedFilter={setEditedFilter}
          />
        ) : (
          <>
            <OLButton
              className={classes.sidebarBtn}
              onClick={clearFilters}
              data-test-id="clear-filters"
            >
              {message({ id: "clearFilters" })}
            </OLButton>
            {selectedFilters.map((filter, index) => {
              return (
                <OLButton
                  key={index}
                  endIcon={<ChevronRightIcon />}
                  className={classes.filterBox}
                  onClick={() =>
                    setEditedFilter({ filter: filter, index: index })
                  }
                >
                  <span className={classes.filterSidebarValue}>
                    {filter.label}: {parseFilterValue(filter, message)}
                  </span>
                </OLButton>
              );
            })}
          </>
        )}
      </div>
    </Drawer>
  );
}
